import { FrameName } from "../config";
import AbstractSalvageableFightableEnemyTileEntity from "./AbstractSalvageableFightableEnemyTileEntity";

class ShallowSeaRaidersSkiffSalvageableTileEntity extends AbstractSalvageableFightableEnemyTileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_RAIDERS_SKIFF;
}

export default ShallowSeaRaidersSkiffSalvageableTileEntity;
